import { render } from "./ColumnInfo.vue?vue&type=template&id=3dd38c93"
import script from "./ColumnInfo.vue?vue&type=script&lang=js"
export * from "./ColumnInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__